import Checkbox from '../../../plugins/checkbox.js';
export default Checkbox;